
const English = {
    actions: {
        startCall: "Start A Call",
        leaveCall: "Leave This Call",
        muteMe: "Mute My Audio",
        unmuteMe: "Unmute My Audio",
        hideMe: "Hide My Video",
        showMe: "Show My Video",
        copyChannel: "Copy a link to this channel"
    }
}

export default English;